import styled from 'styled-components';
import { rem } from 'polished';
var TitleContainer = styled.div.withConfig({
  displayName: "TitleContainer",
  componentId: "sc-1nhwwlg-0"
})(["float:left;padding-bottom:", ";padding-top:", ";"], rem(8), rem(8));
export default TitleContainer;